import { SiteBodyContent } from './loaders';

export const MobileBody = () => <SiteBodyContent />;
